// Helpers for customer logos served by the attachment service.
// REACT_APP_BUCKET_API_URL is the attachment API base (e.g. "/attachment/api").
const BUCKET = process.env.REACT_APP_BUCKET_API_URL || '';

// Where to POST a logo image (field name: "files")
export const uploadLogoUrl = `${BUCKET}/attachments/logo`;

// Static files are served at "<service root>/uploads/<filename>"
const uploadsBase = `${BUCKET.replace(/\/api\/?$/, '')}/uploads`;

export const logoUrl = (filename?: string | null): string =>
    filename ? `${uploadsBase}/${filename}` : '';
